import React, { useState, useEffect } from 'react';
import apiService from '../../../Common/Configurations/APIService';
import config from '../../../Common/Configurations/APIConfig';
import TemplateControls from '../../../template-library/TemplateControls';
import TemplatePreview from '../../../template-library/TemplatePreview';
import StyleBuilder from '../../../template-library/StyleBuilder';
import '../../../template-library/global-styles.css'
import { useAuth } from '../../../Common/Configurations/AuthContext';
import Header from '../../../Common/Layout/Header';
import AdminTabs from '../AdminTabs';

// Main styles for the two-pane layout
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: 'calc(100vh - 100px)',
    borderTop: '1px solid #ddd',
  },
  controls: {
    width: '350px',
    padding: '20px',
    overflowY: 'auto',
    backgroundColor: '#f8f9fa',
    borderRight: '1px solid #ddd',
  },
 preview: {
  flex: 1,
  overflowY: 'auto',
  backgroundColor: '#fff',
  position: 'relative'
}
};

const availableComponents = {
    topBars:['TopBar1', 'TopBar2', 'TopBar3','TopBar4','TopBar5','TopBar6' ,'TopBar7' ,'TopBar8' ,'TopBar9' ,'TopBar10' ,'None'],
    headers:['TemplateHeader1', 'TemplateHeader2', 'TemplateHeader3','TemplateHeader4', 'TemplateHeader5','TemplateHeader6','TemplateHeader7','TemplateHeader8','TemplateHeader9','TemplateHeader10','TemplateHeaderHybrid','TemplateHeaderHybrid2'],
    heroes:['TemplateHero1', 'TemplateHero2', 'TemplateHero3', 'TemplateHero4', 'TemplateHero5','TemplateHero6','TemplateHero7','TemplateHero8','TemplateHeroTabbedSearch','TemplateHeroTabbedSearch2','TemplateHero20', 'TemplateHero21', 'TemplateHero22', 'TemplateHero23', 'TemplateHero24', 'TemplateHero25', 'TemplateHero26', 'TemplateHero27', 'TemplateHero28', 'TemplateHero29'],
    destinations:['Destinations1','Destinations2','Destinations3','Destinations4','Destinations5','Destinations6', 'Destinations7','Destinations8','Destinations9','Destinations10','None'],
    packages:['FeaturedPackages1', 'FeaturedPackages2','FeaturedPackages8','FeaturedPackages9','FeaturedPackages10', 'FeaturedPackages11','FeaturedPackages12','None'],
    packagesPage: ['PackagesListPage1', 'None'],
    detailsPage:['PackageDetails1', 'None'],
    testimonials: ['Testimonials1','Testimonials2', 'None'],
    aboutUs:['AboutUs1', 'AboutUs2', 'AboutUs3', 'None'],
    footers:['TemplateFooter1', 'TemplateFooter2', 'TemplateFooter3'],
    contactUs: ['Contact1', 'None'],
    contactPage:['ContactPage1', 'None'],
    
    // 👇 MAKE SURE THESE EXACT NAMES ARE HERE:
    flightThemes:['FlightTheme1', 'FlightTheme2', 'FlightTheme4', 'FlightTheme5','FlightTheme6','FlightTheme7', 'FlightTheme8', 'None'],
    hotelsPage: ['HotelSearch1', 'HotelSearch2', 'None'],
    sightseeingPage: ['SightseeingList1', 'None'],
    visasPage: ['VisaForm1', 'None'],
    busThemes: ['BusTheme1', 'BusTheme2', 'BusTheme3','BusTheme4','None'], 
    carsPage:['CarSearch1', 'None']
};

function CreateTemplate() {
  const[templateName, setTemplateName] = useState('');
  const [description, setDescription] = useState('');
  const[thumbnail, setThumbnail] = useState(null);
  const [viewState, setViewState] = useState({
    name: 'home',
    params: null
  });

  const handleNavigate = (viewConfig) => {
    setViewState(viewConfig);
  };

  // 👇 NEW: 1. State for Template Type
  const [templateType, setTemplateType] = useState('Travel Website');

  // 👇 NEW: 2. State for B2C Selected Modules
  const [selectedModules, setSelectedModules] = useState({
    Packages: false, // Default to true
    Flights: false,
    Hotels: false,
    Sightseeing: false,
    Visas: false,
    Buses: false,
    Cars: false
  });

const [layout, setLayout] = useState({
    topBar: 'TopBar1',
    header: 'TemplateHeader1',
    hero: 'TemplateHero1',
    destinations: 'None',
    packages: 'FeaturedPackages1',
    testimonials: 'None',
    aboutUs: 'AboutUs1',
    footer: 'TemplateFooter1',
    destinationsPage: 'DestinationsList1',
    packagesPage: 'PackagesListPage1',
    detailsPage: 'PackageDetails1',
    contactPage: 'ContactPage1',
    
    // 👇 MAKE SURE THIS SAYS 'flightTheme' (Not flightsPage)
    flightTheme: 'FlightTheme2', 
    
    hotelsPage: 'None',
    sightseeingPage: 'None',
    visasPage: 'None',
   busTheme: 'BusTheme1', 
    carsPage: 'None'
  });

  const { user } = useAuth();
  const previewBranding = {
      phone: user?.companyPhone || "+1 (555) 123-4567",
      email: user?.companyEmail || "admin@trawtel.com",
       logoUrl: user?.logo || "https://via.placeholder.com/150x50?text=Company+Logo",
      companyName: user?.companyName || "Trawtel",
      // 👇 FIX: Added brandName
      brandName: user?.brandName || "Trawtel"
  };

  const [styleConfig, setStyleConfig] = useState({
    primary: "#007bff",
    secondary: "#6c757d",
     topBar: {
      bgColor: "#f8f9fa",
      textColor: "#212529"
    },
    header: {
      bgColor: "#007bff",
      linkColor: "#ffffff",
      textColor: "#ffffff"
    },
    hero: {
      overlayColor: "rgba(0, 0, 0, 0.4)",
      subtitleColor: "#e9ecef" 
    },
     body: {
      bgColor: "#ffffff",
      textColor: "#333333",
      fontFamily: "'Inter', sans-serif"
    },
    footer: {
      bgColor: "#2c3e50",
      textColor: "#ecf0f1",
      linkColor: "#bdc3c7"
    }
  });

  const [defaultDestinations, setDefaultDestinations] = useState([
    { name: "Dubai", image: "https://images.pexels.com/photos/208701/pexels-photo-208701.jpeg", description: "" },
    { name: "Paris", image: "https://images.pexels.com/photos/1285625/pexels-photo-1285625.jpeg", description: "" },
    { name: "New York", image: "https://images.pexels.com/photos/2161449/pexels-photo-2161449.jpeg", description: "" },
    { name: "Tokyo", image: "https://images.pexels.com/photos/373945/pexels-photo-373945.jpeg", description: "" },
  ]);

  const [defaultHeroData, setDefaultHeroData] = useState({
    slides:[
      {
        image: "https://i.pinimg.com/1200x/95/3b/dc/953bdc7540fa82c7d7f6c29d2b53f67a.jpg",
        title: "Your Next Adventure Awaits",
        subtitle: "Explore our curated packages to the world's most breathtaking destinations."
      }
    ]
  });
  // 1. Initial state can just be empty or basic, the useEffect will overwrite it immediately
  const[headerMenu, setHeaderMenu] = useState([]);

  // 👇 2. NEW: Auto-generate the Header Menu based on selected modules!
// Inside CreateTemplate.js
// Inside CreateTemplate.js
React.useEffect(() => {
    const newMenu = [];

    // 1. HOME (First)
    if (templateType === 'Travel Website') {
      newMenu.push({ id: "home", label: "Home", path: "/" });
    }

    // 2. HOLIDAY SERVICES (Destinations/Packages)
    if (templateType === 'Travel Website' || (templateType === 'B2C Website' && selectedModules.Packages)) {
      newMenu.push({ id: "destinations", label: "Destinations", path: "/destinations" });
      newMenu.push({ id: "packages", label: "Holiday Packages", path: "/packages" });
    }

    // 3. B2C SERVICES (Flights, Hotels, Buses, etc.)
    if (templateType === 'B2C Website') {
      if (selectedModules.Flights) newMenu.push({ id: "flights", label: "Flights", path: "/flights" });
      if (selectedModules.Hotels) newMenu.push({ id: "hotels", label: "Hotels", path: "/hotels" });
      if (selectedModules.Sightseeing) newMenu.push({ id: "sightseeing", label: "Sightseeing", path: "/sightseeing" });
      if (selectedModules.Visas) newMenu.push({ id: "visas", label: "Visas", path: "/visas" });
      if (selectedModules.Buses) newMenu.push({ id: "buses", label: "Buses", path: "/buses" });
      if (selectedModules.Cars) newMenu.push({ id: "cars", label: "Cars", path: "/cars" });
    }

    // 4. ABOUT US (Now pushed AFTER services)
    newMenu.push({ id: "about", label: "About Us", path: "/about" });

    // 5. CONTACT US (Last)
    newMenu.push({ id: "contact", label: "Contact Us", path: "/contact" });

    setHeaderMenu(newMenu);
}, [templateType, selectedModules]);// Re-runs when type or modules change// <-- Re-runs every time Admin changes type or checks a box
  useEffect(() => {
  if (templateType === 'B2C Website') {
      // Check ALL modules in order of preference
      if (selectedModules.Flights) setViewState({ name: 'flights', params: null });
      else if (selectedModules.Hotels) setViewState({ name: 'hotels', params: null });
      else if (selectedModules.Buses) setViewState({ name: 'buses', params: null }); // 👈 ADDED
      else if (selectedModules.Visas) setViewState({ name: 'visas', params: null }); // 👈 ADDED
      else if (selectedModules.Sightseeing) setViewState({ name: 'sightseeing', params: null }); // 👈 ADDED
      else if (selectedModules.Cars) setViewState({ name: 'cars', params: null }); // 👈 ADDED
      else setViewState({ name: 'home', params: null });
    } else {
      setViewState({ name: 'home', params: null });
    }
  },[templateType, selectedModules]);

  const [footerData, setFooterData] = useState({
    aboutText: "Discover the world with us. We offer curated packages and unforgettable experiences.",
    copyright: "All Rights Reserved."
  });

  const[aboutData, setAboutData] = useState({
    title: "Defining the Future of Travel",
    description: "Welcome to our agency. We specialize in creating unique experiences that last a lifetime.",
    image: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg"
  });

  const [contactData, setContactData] = useState({
    title: "Get In Touch",
    description: "Plan your next dream vacation with our experts.",
    mapIframeUrl: "https://www.google.com/maps/embed?pb=...",
    officeHours: "Mon-Sat: 9 AM - 6 PM"
  });

  const[btnLoading, setBtnLoading] = useState(false);

 const handleSubmit = async (e) => {
    e.preventDefault();
    if (!templateName || !thumbnail) {
      alert("Template Name and Thumbnail are required.");
      return;
    }
    setBtnLoading(true);

    try {
      // 👇 NEW LOGIC: Clean the layout JSON before saving!
      // Copy the current layout state
      const finalLayout = { ...layout };

      // If B2C, check the toggles. If a toggle is OFF, set its theme to "None"
      if (templateType === 'B2C Website') {
        if (!selectedModules.Packages) {
            finalLayout.destinations = 'None';
            finalLayout.packages = 'None';
            finalLayout.packagesPage = 'None';
            finalLayout.detailsPage = 'None';
        }
        if (!selectedModules.Flights) finalLayout.flightTheme = 'None';
        if (!selectedModules.Hotels) finalLayout.hotelsPage = 'None';
        if (!selectedModules.Sightseeing) finalLayout.sightseeingPage = 'None';
        if (!selectedModules.Visas) finalLayout.visasPage = 'None';
        if (!selectedModules.Buses) finalLayout.busTheme = 'None';
        if (!selectedModules.Cars) finalLayout.carsPage = 'None';
      }

      const formData = new FormData();
      formData.append('Name', templateName);
      formData.append('Description', description);

      // 👇 Use finalLayout here instead of the raw layout state!
      formData.append('LayoutJson', JSON.stringify(finalLayout)); 

      formData.append('StyleJson', JSON.stringify(styleConfig)); 
      formData.append('Thumbnail', thumbnail);

      formData.append('TemplateType', templateType);
      formData.append('SupportedModulesJson', JSON.stringify(selectedModules));

      formData.append('DefaultDestinationsJson', JSON.stringify({ destinations: defaultDestinations }));
      formData.append('DefaultHeroJson', JSON.stringify(defaultHeroData));
      formData.append('DefaultHeaderJson', JSON.stringify(headerMenu));
      formData.append('DefaultFooterJson', JSON.stringify(footerData));
      formData.append('DefaultAboutJson', JSON.stringify(aboutData));
      formData.append('DefaultContactJson', JSON.stringify(contactData)); 

      await apiService.postWithFile(config.CREATETEMPLATE, formData, true);
      alert("Template Created Successfully!");
      
    } catch (error) {
      console.error("Failed to create template:", error);
    } finally {
      setBtnLoading(false);
    }
  };
  return (
    <div>
      <div style={styles.container}>
        <div style={styles.controls}>
          <p className="badge bg-info">Editing View: {viewState.name.toUpperCase()}</p>
          <TemplateControls
            templateName={templateName}
            setTemplateName={setTemplateName}
            description={description}
            setDescription={setDescription}
            setThumbnail={setThumbnail}
            layout={layout}
            setLayout={setLayout}
            btnLoading={btnLoading}
            handleSubmit={handleSubmit}
            availableComponents={availableComponents}
            styleConfig={styleConfig}
            setStyleConfig={setStyleConfig}
            
            // 👇 NEW PROPS PASSED HERE
            templateType={templateType}
            setTemplateType={setTemplateType}
            selectedModules={selectedModules}
            setSelectedModules={setSelectedModules}
          />
        </div>
        <div style={styles.preview}>
          <TemplatePreview 
              layout={layout} 
              styleConfig={styleConfig} 
              destinations={defaultDestinations} 
              heroData={defaultHeroData}
              branding={previewBranding}
              headerMenu={headerMenu} 
              footerData={footerData}
              viewState={viewState} 
              aboutData={aboutData} 
              contactData={contactData}
              onNavigate={handleNavigate} 
              mode="builder"
          />
        </div>
      </div>
    </div>
  );
}

export default CreateTemplate;